import { render, staticRenderFns } from "./TestDetails.vue?vue&type=template&id=0b9c2c4f"
import script from "./TestDetails.vue?vue&type=script&lang=js"
export * from "./TestDetails.vue?vue&type=script&lang=js"
import style0 from "./TestDetails.vue?vue&type=style&index=0&id=0b9c2c4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports